import styled from 'styled-components'
import { Modal } from '@77sol-ui/molecules'

export const ModalClose = styled(Modal.Close)`
  position: initial;
  margin-left: auto;
`
